export const setAuthenticators = (state, action) => {
  state.authAccessToken = action.payload.accessToken;
  state.authGroups = action.payload.claims.groups;
  state.authUserId = action.payload.claims.user_id;
};
